import React, {createRef} from 'react'

import ModalV4 from "../../../app/ui/modal/v4/v4"
import VScroll from "../../gd-components/scrolling/custom-v-scroll/v-scroll"
import ModalV4HeaderWhite from "../../../app/ui/modal/v4/header-white/v4-header-white"
import SharedViewForm from "./form-edit"
import Loading from '../../gd-ui/loading/loading'
import {ViewType} from "../../gd/const/views/view-type"
import {PublicSharingType, SharedViewConfig} from "./@types"

type Props = {
    params: {
        sharedViewId: string
        title       : string
        type        : number
        config      : any
        sharingType : PublicSharingType
        onCallback  : func
    }
}

export default class ModalShareView extends ModalV4 {

    private sharedViewFormRef = createRef<any>()

    constructor(props: Props) {
        super(props);

        this.state = {
            loading: !!this.props.params.sharedViewId
        }
    }

    async componentDidMount() {
        if (this.props.params.sharedViewId) {
            try {
                const response = await gd.api.ShareView.get(this.props.params.sharedViewId).promise()

                this.setState({
                    loading : false,
                    data    : response
                })
            } catch(e: any) {
                this.setState({
                    loading : false,
                    data    : null
                })
            }
        }
    }

    _getSharedViewConfig = (config: SharedViewConfig) => {
        return _.assign({}, config, this.props.params.config)
    }

    onCreate = async (config: SharedViewConfig) => {
        const response = await gd.api.ShareView.create(this.props.params.type, this.props.params.title, this._getSharedViewConfig(config), this.props.params.sharingType).promise()
        this.props.params.onCallback(response)
        this.sharedViewFormRef.current?.setData(response)
    }

    onEdit = async (sharedViewId: ID, title: string, config: any) => {
        const response = await gd.api.ShareView.update(sharedViewId, this.props.params.type, title, this._getSharedViewConfig(config)).promise()
        this.props.params.onCallback(response)
    }

    onRemove = async (sharedViewId: ID) => {
        const response = await gd.api.ShareView.delete(sharedViewId).promise()
        this.props.params.onCallback(response);
        this.sharedViewFormRef.current?.setData(null);
    }

    _showOpenTasks = () => {
        switch (this.props.params.type) {
            case ViewType.PROJECTS_PORTFOLIO    :
            case ViewType.PROJECT_DOCS          :
            case ViewType.PORTFOLIO_SUMMARY     :
            case ViewType.PROJECT_PAGE          : return false

            default                             : return true
        }
    }

    _showOpenEvents = () => {
        switch (this.props.params.type) {
            case ViewType.PROJECT_CALENDAR          :
            case ViewType.CUSTOM_VIEW_CALENDAR      :
            case ViewType.CUSTOM_VIEW_WHATS_DONE    : return true

            default                                 : return false
        }
    }

    _showOpenDocs = () => {
        switch (this.props.params.type) {
            case ViewType.PROJECT_DOCS  : return true
            default                     : return false
        }
    }

    renderForm() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <ModalV4HeaderWhite height={60} title="Public sharing"/>
                <VScroll>
                   <SharedViewForm ref              = {this.sharedViewFormRef}
                                   showOpenTasks    = {this._showOpenTasks()}
                                   showOpenEvents   = {this._showOpenEvents()}
                                   showOpenDocs     = {this._showOpenDocs()}
                                   data             = {this.state.data}
                                   onCreate         = {this.onCreate}
                                   onEdit           = {this.onEdit}
                                   onRemove         = {this.onRemove}/>
                </VScroll>
            </div>
        )
    }

    render() {
        return this.state.loading ? <Loading/> : this.renderForm()
    }
}